import {Module} from "../index";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {GameCreationEventSubscriber} from "./subscribers/GameCreationEventSubscriber";
import {GroundSlot} from "@/modules/club-grounds/entity";
import SlotUnlocker from "@/modules/club-grounds/services/SlotUnlocker";
import {GroundSlotEventSubscriber} from "@/modules/club-grounds/subscribers/GroundSlotEventSubscriber";
import SlotDeveloper from "@/modules/club-grounds/services/SlotDeveloper";
import SlotDemolisher from "@/modules/club-grounds/services/SlotDemolisher";
import {EffectsEventSubscriber} from "@/modules/club-grounds/subscribers/EffectsEventSubscriber";
import GroundSlotConfigProvider from "@/modules/club-grounds/services/GroundSlotConfigProvider";
import AggregatedEffectProvider from "@/modules/club-grounds/services/AggregatedEffectProvider";

export class ClubGroundsModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [
    GroundSlot,
  ];

  eventSubscribers = [
    GameCreationEventSubscriber,
    GroundSlotEventSubscriber,
    EffectsEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<SlotUnlocker>(SlotUnlocker).to(SlotUnlocker);
    this.app.bind<SlotDeveloper>(SlotDeveloper).to(SlotDeveloper);
    this.app.bind<SlotDemolisher>(SlotDemolisher).to(SlotDemolisher);
    this.app.bind<GroundSlotConfigProvider>(GroundSlotConfigProvider).to(GroundSlotConfigProvider);
    this.app.bind<AggregatedEffectProvider>(AggregatedEffectProvider).to(AggregatedEffectProvider);
  }

  boot() {
    super.boot();
  }
}
